import React from "react";
import "./App.css";
import Layout from "./HOC/Layout/Layout";
import Home from "./Components/Routes/Home/Home";
import About from "./Components/Routes/About/About";
import Search from "./Components/Routes/Search/Search";
import Menu from "./Components/Routes/Menu/Menu";
import Post from "./Components/Routes/Post/Post";
import FullRecipe from "./Components/Routes/FullRecipe/FullRecipe";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./contexts/authContext";
import {
  Login,
  Signup,
  PrivateRoute,
  ForgotPassword,
  UpdateProfile,
} from "./Container";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Layout>
          {/* <Home /> */}
          <Switch>
            <Route path="/about" component={About} />
            <PrivateRoute path="/search" component={Search} />
            <PrivateRoute path="/recipes/:id" component={FullRecipe} />
            <PrivateRoute path="/updateProfile" component={UpdateProfile} />
            <Route exact path="/recipes" component={Menu} />
            <PrivateRoute path="/post" component={Post} />
            <Route exact path="/" component={Home} />
            <Route path="/signup" component={Signup} />
            <Route path="/login" component={Login} />
            <Route path="/forgotPassword" component={ForgotPassword} />
          </Switch>
        </Layout>
      </AuthProvider>
    </Router>
  );
}

export default App;
